import { render, staticRenderFns } from "./ChatEditModal.vue?vue&type=template&id=54347b50"
import script from "./ChatEditModal.vue?vue&type=script&lang=js"
export * from "./ChatEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports